<template>
  <div>
    <v-btn
      class="error mr-2"
      v-if="isClosed"
      @click="undoCloseDay"
    >
      {{ $t('sharedCommon.undoCloseDay') }}
      <v-icon>mdi-undo-variant</v-icon>
    </v-btn>
    <v-btn
      :class="{success:!isOpen, error: isOpen}"
      @click="confirmSwitchOutletStatus()"
    >
      {{ translatedSwitchString }}
      <v-icon>mdi-play</v-icon>
    </v-btn>
    <SwitchWorkingDayDialog
      :title="title"
      :dialog-visible="dialogVisible"
      @close="dialog(false)"
      @submit="submit"
      :key="`${_uid}-${dialogKey}`"
      @dayClosed="$emit('dayClosed')"
    />
  </div>
</template>

<script lang="ts">
import {Mixins, Component, Prop} from "vue-property-decorator";
import IndexMixin from "@/mixins";
import SwitchWorkingDayDialog from "./SwitchWorkingDayDialog.vue";
import {POSClosedDay} from "@/models/POSClosedDay";
import WDMixin from "../mixins";
import PermissionHelper from "@/permissions/PermissionHelper";
import {ActionButtonEnum} from "@/permissions/ActionButtonEnum";
import signalGo from "@/services/SignalGo";

@Component({
  mixins: [IndexMixin, WDMixin],
  components: {
    SwitchWorkingDayDialog
  },
})
export default class POSWorkingDaySwitchButton extends Mixins(IndexMixin, WDMixin) {
  public dialogVisible: boolean = false;
  public dialogKey: number = 0;

  public confirmSwitchOutletStatus() {
    this.dialog(true);
  }

  get title() {
    return this.$t("menu.workingDay").toString();
  }

  get translatedSwitchString() {
    return this.$t("localCommon." + this.switchString.toLowerCase().replace(" ","") + "Day").toString();
  }

  // Dialog methods
  public dialog(stat: boolean) {
    this.dialogVisible = stat;
    if (!stat) this.dialogKey = this.dialogKey + 1;
  }

  public submit(formData: POSClosedDay) {
  }

  public undoCloseDay() {
    const hasPermission = PermissionHelper.canAccessButton(ActionButtonEnum.ACTION_ALLOW_USER_TO_UNDO_CLOSE_DAY);
    if (hasPermission) {
      this.$archConfirm({
        confirmButtonColor: "error",
        cancelButtonColor: "",
        message: "Are you sure?",
        title: "Undo Close Working Day",
        width: 400
      })
        .then(async () => {
          signalGo.Subscribe(`pos_undo_close_day_${this.outletId}`, (e) => {
            const message = e.content.message || e.content.error;
            const status = e.content.success;
            signalGo.Unsubscribe(`pos_undo_close_day_${this.outletId}`);
            if (status) {
              this.succNotify(message);
              location.reload();
            } else {
              this.errNotify(message);
            }
          });
          try {
            await this.$http.post("/longrequest/hotel/{hotelId}/pos/{outletId}/undo-close-day/v1");
          } catch (e) {
            this.errNotify("Something went wrong");
            console.error(e);
          }
        });
    } else {
      PermissionHelper.showAlertPermission();
    }
  }

}
</script>

<style scoped>

</style>
